import React from 'react'
import { MetaData } from 'lib/shared'
import { PageType, SliceResolver } from 'modules/prismic'
import { PageWrapper } from './styled'

export const PrismicPageScene = ({ data }: PageType) => {
  const { body } = data

  return (
    <>
      <MetaData
        title={data?.meta_title}
        description={data?.meta_description}
        keywords={data?.meta_keywords}
      />
      <PageWrapper>
        {body?.map((slice: any, i: number) => {
          return <SliceResolver key={i} slice={slice} />
        })}
      </PageWrapper>
    </>
  )
}
